import styled from "@doar/shared/styled";

interface StyledLoaderProps {
  $animationDelay?: string;
}

export const StyledLoader = styled.div<StyledLoaderProps>`
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 250, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;

  .animation-container {
    width: 150px;
    max-width: 90%;
  }

  .logo-svg {
    width: 100%;
    height: auto;
    overflow: visible;
  }

  .left-hand-animator {
    transform: translate(-20%, 5px);
    opacity: 0;
    animation: move-left 2.4s ease-in-out infinite;
    animation-delay: ${(props) => props.$animationDelay || "0s"};
    animation-fill-mode: both;
    animation-play-state: running;
    will-change: transform, opacity;
  }

  .right-hand-animator {
    transform: translate(20%, 5px);
    opacity: 0;
    animation: move-right 2.4s ease-in-out infinite;
    animation-delay: ${(props) => props.$animationDelay || "0s"};
    animation-fill-mode: both;
    animation-play-state: running;
    will-change: transform, opacity;
  }

  @keyframes move-left {
    0% {
      transform: translate(-20%, 5px);
      opacity: 0;
    }
    12% {
      opacity: 1;
    }
    24% {
      transform: translate(0, 0);
      opacity: 1;
    }
    74% {
      transform: translate(0, 0);
      opacity: 1;
    }
    87%,
    100% {
      transform: translate(0, 0);
      opacity: 0;
    }
  }

  @keyframes move-right {
    0% {
      transform: translate(20%, 5px);
      opacity: 0;
    }
    12% {
      opacity: 1;
    }
    24% {
      transform: translate(0, 0);
      opacity: 1;
    }
    74% {
      transform: translate(0, 0);
      opacity: 1;
    }
    87%,
    100% {
      transform: translate(0, 0);
      opacity: 0;
    }
  }
`;
